<app-page-header
  class="header"
  [inside]="true"
  [backSwipe]="backSwipeConfig"
  (backButtonClick)="back.emit()"
/>

<div class="content">
  <div class="item">
    <img class="item__image" src="/images/pages/blue-jays.webp" width="550" height="310" alt="Apparel 1"/>

    <div class="qr__wrapper">
      <app-qrcode content="https://oon.gl/TFXH4w"/>
      <span class="label">Shop Now</span>
    </div>
  </div>

  <div class="item">
    <img class="item__image" src="/images/pages/buffalo.webp" width="550" height="310" alt="Apparel 1"/>

    <div class="qr__wrapper">
      <app-qrcode content="https://oon.gl/76QkC2"/>
      <span class="label">Shop Now</span>
    </div>
  </div>

  <div class="item">
    <img class="item__image" src="/images/pages/sale.webp" width="550" height="310" alt="Apparel 1"/>

    <div class="qr__wrapper">
      <app-qrcode content="https://oon.gl/TqwABH"/>
      <span class="label">Shop Now</span>
    </div>
  </div>

</div>
